import Api from '@/api'
import Constants from '@/util/constants'

export default {
  getCatalog (params) {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}${params.outletId}/catalog`
    })
  },

  getSoldOut (params) {
    const MARKET_URL = Constants.URL.MARKET_URL

    return Api.request({
      url: `${MARKET_URL}${params.outletId}/soldout`
    })
  }
}
